import { render } from "./insights-left-panel-lite.vue?vue&type=template&id=3c61e288"
import script from "./insights-left-panel-lite.vue?vue&type=script&lang=js"
export * from "./insights-left-panel-lite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__